/**************************************************************************
 *
 * Snippet Sniffer Hook
 *
 * Author:         Robert Bleeks
 * Date:           September 2026
 *
 **************************************************************************/

import {
    useState
}
from "react";

import {
    functions
}
from "../../../constants/common-functions";


export default function useSnippetSniffer()
{
    const [loading,
           setLoading] =
        useState(false);

    const [query,
           setQuery] =
        useState("");

    const [results,
           setResults] =
        useState([]);

    const [total,
           setTotal] =
        useState(0);

    const [page,
           setPage] =
        useState(0);

    const [size,
           setSize] =
        useState(25);

    const [selectedSnippet,
           setSelectedSnippet] =
        useState(null);

    const [snippetContext,
           setSnippetContext] =
        useState(null);


    /**********************************************************************
     *
     * Search
     *
     **********************************************************************/

    function search(
        searchQuery,
        searchPage = 0,
        searchSize = size)
    {
        if(!searchQuery ||
           searchQuery.trim() === "")
        {
            setQuery("");
            setResults([]);
            setTotal(0);
            setPage(0);

            return;
        }

        setLoading(true);

        functions.getObjectFromAjax(

            "/resolutionsoftwareplatform/snippet-sniffer/search?q=" +

            encodeURIComponent(
                searchQuery.trim()
            ) +

            "&page=" +
            searchPage +

            "&size=" +
            searchSize,

            function(data)
            {
                setQuery(
                    data.query
                );

                setResults(
                    data.results || []
                );

                setTotal(
                    data.total || 0
                );

                setPage(
                    data.page || 0
                );

                setSize(
                    data.size || searchSize
                );

                setLoading(false);
            },

            null
        );
    }


    /**********************************************************************
     *
     * Select Snippet
     *
     **********************************************************************/

    function selectSnippet(
        snippet)
    {
        setSelectedSnippet(
            snippet
        );

        loadSnippetContext(
            snippet.snippetId
        );
    }


    /**********************************************************************
     *
     * Load Snippet Context
     *
     **********************************************************************/

    function loadSnippetContext(
        snippetId,
        pages = 2)
    {
        setLoading(true);

        functions.getObjectFromAjax(

            "/resolutionsoftwareplatform/snippet-sniffer/snippets/" +

            snippetId +

            "/context?pages=" +

            pages,

            function(data)
            {
                setSnippetContext(
                    data
                );

                setLoading(false);
            },

            null
        );
    }


    /**********************************************************************
     *
     * Clear Selected Snippet
     *
     **********************************************************************/

    function clearSelectedSnippet()
    {
        setSelectedSnippet(null);
        setSnippetContext(null);
    }


    /**********************************************************************
     *
     * Next Page
     *
     **********************************************************************/

    function nextPage()
    {
        if(
            (page + 1) * size <
            total
        )
        {
            search(
                query,
                page + 1,
                size
            );
        }
    }


    /**********************************************************************
     *
     * Previous Page
     *
     **********************************************************************/

    function previousPage()
    {
        if(page > 0)
        {
            search(
                query,
                page - 1,
                size
            );
        }
    }


    return {

        loading,

        query,

        results,

        total,

        page,

        size,

        selectedSnippet,

        snippetContext,

        search,

        selectSnippet,

        loadSnippetContext,

        clearSelectedSnippet,

        nextPage,

        previousPage
    };
}